import { differenceInDays } from 'date-fns';

const cacheInDays = 100; // ± 3 months

// checks if update is needed on cache: if no date is available or after cacheInDays
export const checkUpdateNeeded = (dateStr?: string): boolean =>
  dateStr
    ? differenceInDays(new Date(), new Date(dateStr)) > cacheInDays
    : true;
